export class CoveragesConstant {
    public static readonly ALL_RIDERS = "AllRiders";
    public static readonly LLOP = "LLOP";
    public static readonly LLTP = "LLTP";
    public static readonly WINDSCREEN = "WindScreen";
    public static readonly SPECIAL_PERILS = "SpecialPerils";
    public static readonly ALL_DRIVERS = "AllDrivers";
  }
  